/**
 * 消息中心
 */
import messageApi from '../../api/message.api'

const state = {
    classifyList: [],
    messageList: [],
    newTotal: 0,
    total: 0
};

const getters = {
    getClassifyItem: state => _id => {
        return state.classifyList.find(item => item._id === _id) || {};
    }
};

const mutations = {
    setClassify(state, data) {
        state.classifyList = data;
    },
    setMessageList(state, data) {
        state.messageList = data.list;
        state.total = data.total;
        state.newTotal = data.newTotal;
    },
    setNewTotal(state, data) {
        state.newTotal = data;
    },
    resetMessage(state) {
        state.messageList = [];
        state.newTotal = 0;
        state.total = 0;
    }
};

const actions = {
    // 获取分类
    getClassify({state, commit}) {
        return state.classifyList.length ? state.classifyList : messageApi.getClassify().then(res => {
            commit('setClassify', res);
            return res;
        })
    },
    // 更新消息
    updateMessage({commit, rootState}) {
        if (!rootState.user._id) return;
        return messageApi.updateMessage().then(data => {
            commit('setNewTotal', data);
            return data;
        })
    },
    // 获取消息列表
    getMessageList({state, commit}, params) {
        return messageApi.getList(params).then(res => {
            commit('setMessageList', res);
            return res;
        })
    },
    // 获取消息详细
    getMessageItem({}, id) {
        return messageApi.getItem(id);
    },
    // 删除消息
    delMessage({}, params) {
        return messageApi.delMessage(params);
    },
    // 设置消息已读
    readMessage({}, params) {
        return messageApi.readMessage(params);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./app/store/modules/message.js